// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__1VdbG","black":"styles_black__9n_sH","grey":"styles_grey__14dgf","red":"styles_red__2dNH5"};